/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsGroupReference,
    ElementsGroupReferenceFromJSON,
    ElementsGroupReferenceFromJSONTyped,
    ElementsGroupReferenceToJSON,
    ElementsUserMiniReference,
    ElementsUserMiniReferenceFromJSON,
    ElementsUserMiniReferenceFromJSONTyped,
    ElementsUserMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaRootPermissionUpdate
 */
export interface MediaRootPermissionUpdate {
    /**
     * 
     * @type {ElementsUserMiniReference}
     * @memberof MediaRootPermissionUpdate
     */
    user?: ElementsUserMiniReference;
    /**
     * 
     * @type {ElementsGroupReference}
     * @memberof MediaRootPermissionUpdate
     */
    group?: ElementsGroupReference;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    allowRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    allowCreate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    allowWriteFs?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    allowWriteDb?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    allowProxyDownload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    allowOriginalDownload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    allowUpload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    allowSharing?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    allowDeleteFs?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    allowDeleteDb?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    showTags?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    showComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    showLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    showCustomFields?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    showRatings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    showSubclips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    showSubtitles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    showAiMetadata?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    showMarkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootPermissionUpdate
     */
    showHistory?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRootPermissionUpdate
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof MediaRootPermissionUpdate
     */
    root: number;
    /**
     * 
     * @type {number}
     * @memberof MediaRootPermissionUpdate
     */
    isTemporaryForToken?: number | null;
}

export function MediaRootPermissionUpdateFromJSON(json: any): MediaRootPermissionUpdate {
    return MediaRootPermissionUpdateFromJSONTyped(json, false);
}

export function MediaRootPermissionUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaRootPermissionUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': !exists(json, 'user') ? undefined : ElementsUserMiniReferenceFromJSON(json['user']),
        'group': !exists(json, 'group') ? undefined : ElementsGroupReferenceFromJSON(json['group']),
        'allowRead': !exists(json, 'allow_read') ? undefined : json['allow_read'],
        'allowCreate': !exists(json, 'allow_create') ? undefined : json['allow_create'],
        'allowWriteFs': !exists(json, 'allow_write_fs') ? undefined : json['allow_write_fs'],
        'allowWriteDb': !exists(json, 'allow_write_db') ? undefined : json['allow_write_db'],
        'allowProxyDownload': !exists(json, 'allow_proxy_download') ? undefined : json['allow_proxy_download'],
        'allowOriginalDownload': !exists(json, 'allow_original_download') ? undefined : json['allow_original_download'],
        'allowUpload': !exists(json, 'allow_upload') ? undefined : json['allow_upload'],
        'allowSharing': !exists(json, 'allow_sharing') ? undefined : json['allow_sharing'],
        'allowDeleteFs': !exists(json, 'allow_delete_fs') ? undefined : json['allow_delete_fs'],
        'allowDeleteDb': !exists(json, 'allow_delete_db') ? undefined : json['allow_delete_db'],
        'showTags': !exists(json, 'show_tags') ? undefined : json['show_tags'],
        'showComments': !exists(json, 'show_comments') ? undefined : json['show_comments'],
        'showLocations': !exists(json, 'show_locations') ? undefined : json['show_locations'],
        'showCustomFields': !exists(json, 'show_custom_fields') ? undefined : json['show_custom_fields'],
        'showRatings': !exists(json, 'show_ratings') ? undefined : json['show_ratings'],
        'showSubclips': !exists(json, 'show_subclips') ? undefined : json['show_subclips'],
        'showSubtitles': !exists(json, 'show_subtitles') ? undefined : json['show_subtitles'],
        'showAiMetadata': !exists(json, 'show_ai_metadata') ? undefined : json['show_ai_metadata'],
        'showMarkers': !exists(json, 'show_markers') ? undefined : json['show_markers'],
        'showHistory': !exists(json, 'show_history') ? undefined : json['show_history'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'root': json['root'],
        'isTemporaryForToken': !exists(json, 'is_temporary_for_token') ? undefined : json['is_temporary_for_token'],
    };
}

export function MediaRootPermissionUpdateToJSON(value?: MediaRootPermissionUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': ElementsUserMiniReferenceToJSON(value.user),
        'group': ElementsGroupReferenceToJSON(value.group),
        'allow_read': value.allowRead,
        'allow_create': value.allowCreate,
        'allow_write_fs': value.allowWriteFs,
        'allow_write_db': value.allowWriteDb,
        'allow_proxy_download': value.allowProxyDownload,
        'allow_original_download': value.allowOriginalDownload,
        'allow_upload': value.allowUpload,
        'allow_sharing': value.allowSharing,
        'allow_delete_fs': value.allowDeleteFs,
        'allow_delete_db': value.allowDeleteDb,
        'show_tags': value.showTags,
        'show_comments': value.showComments,
        'show_locations': value.showLocations,
        'show_custom_fields': value.showCustomFields,
        'show_ratings': value.showRatings,
        'show_subclips': value.showSubclips,
        'show_subtitles': value.showSubtitles,
        'show_ai_metadata': value.showAiMetadata,
        'show_markers': value.showMarkers,
        'show_history': value.showHistory,
        'path': value.path,
        'root': value.root,
        'is_temporary_for_token': value.isTemporaryForToken,
    };
}


